import { Units } from '@app/models/units.model';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CurrentUnitsService {
  private currentUnits: Units = Units.Meter;

  public getCurrentUnits(): Units {
    return this.currentUnits;
  }

  public setCurrentUnits(units: Units): void {
    if (typeof units === 'string') {
      this.currentUnits = Units[units as keyof typeof Units];
      return;
    }

    this.currentUnits = units;
  }
}
